/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpdateCustomMetadataEntryValueDto = {
    id?: string;
    type: UpdateCustomMetadataEntryValueDto.type;
};

export namespace UpdateCustomMetadataEntryValueDto {

    export enum type {
        LABEL = 'LABEL',
        USER = 'USER',
        STRING = 'STRING',
        TEAM = 'TEAM',
    }


}
